import { Element } from 'react-scroll'
import {
  DiagnosticCard,
  OsagoDocument,
  OsgopDocument,
  OtherDocument,
  PtsDocument,
  TaxiLicense,
} from '~/features/common/Сars/Documents/ui'
import { Container } from '~/shared/ui/Layout'
import { KaskoDocument } from './ui/KaskoDocument'
import { StsDocument } from './ui/StsDocument'

export const Documents = () => {
  return (
    <>
      <Element name='pts'>
        <Container data-testid='container-pts-documents'>
          <PtsDocument />
        </Container>
      </Element>

      <Element name='sts'>
        <Container data-testid='container-sts-documents'>
          <StsDocument />
        </Container>
      </Element>

      <Element name='taxiLicense'>
        <Container data-testid='container-taxi-license-documents'>
          <TaxiLicense />
        </Container>
      </Element>

      <Element name='osago'>
        <Container data-testid='container-osago-documents'>
          <OsagoDocument />
        </Container>
      </Element>

      <Element name='kasko'>
        <Container data-testid='container-kasko-documents'>
          <KaskoDocument />
        </Container>
      </Element>

      <Element name='dc'>
        <Container data-testid='container-dc-documents'>
          <DiagnosticCard />
        </Container>
      </Element>

      <Element name='osgop'>
        <Container data-testid='container-osgop-documents'>
          <OsgopDocument />
        </Container>
      </Element>

      <Element name='otherDocument'>
        <Container>
          <OtherDocument />
        </Container>
      </Element>
    </>
  )
}
